import { CorpoBadge } from 'app/design/icons/corpo-badge';
import type { ComponentProps } from 'react';
import { View } from 'react-native';
import { Image } from 'expo-image';
import { WhiteLabel } from 'app/types/white-labels';
import { FeatureFlag, isFeatureEnabled, isWhiteLabel } from 'app/utils/helpers';

export function CorpoImage({
  picture,
  color = '#F1F2F2',
  style,
}: {
  picture?: string | null;
  color?: ComponentProps<typeof CorpoBadge>['color'];
  style?: ComponentProps<typeof View>['style'];
}) {
  if (isFeatureEnabled(FeatureFlag.justOneClub) || isWhiteLabel(WhiteLabel.HauteGaspesie)) {
    return null;
  }
  if (!picture) {
    return <CorpoBadge color={color} style={style} />;
  }
  return (
    <View style={style}>
      <Image source={{ uri: picture }} style={{ width: 30, height: 30, borderRadius: 15 }} />
    </View>
  );
}
